import { useRef } from 'react';
import { motion, useScroll, useTransform, MotionValue } from 'framer-motion';

const TESTIMONIAL =
  'SprynAI revolutionized how we handle social media using AI-powered marketing. We are now driving better engagement and growth quicker than we ever imagined! SprynAI revolutionized how we handle social media using AI-powered marketing strategies.';

type WordProps = {
  progress: MotionValue<number>;
  range: [number, number];
  children: string;
};

function Word({ progress, range, children }: WordProps) {
  const opacity = useTransform(progress, range, [0.2, 1]);
  const color = useTransform(progress, range, [
    'hsl(0 0% 35%)',
    'hsl(0 0% 100%)',
  ]);

  return (
    <motion.span
      style={{ opacity, color }}
      className="mr-[0.3em] inline-block"
    >
      {children}
    </motion.span>
  );
}

export default function Testimonial() {
  const containerRef = useRef<HTMLElement>(null);

  const { scrollYProgress } = useScroll({
    target: containerRef,
    offset: ['start end', 'end center'],
  });

  const words = TESTIMONIAL.split(/\s+/);
  const total = words.length;

  return (
    <section
      ref={containerRef}
      id="reviews"
      className="min-h-screen flex items-center justify-center py-24 md:py-32 px-8 md:px-28 bg-background text-foreground"
    >
      <div className="flex flex-col items-start gap-10 max-w-3xl mx-auto w-full">
        <img
          src="/quote-symbol.png"
          alt=""
          aria-hidden="true"
          className="w-14 h-10 object-contain"
        />

        <p className="flex flex-wrap text-4xl md:text-5xl font-medium leading-[1.2]">
          {words.map((word, i) => (
            <Word
              key={`${word}-${i}`}
              progress={scrollYProgress}
              range={[i / total, (i + 1) / total]}
            >
              {word}
            </Word>
          ))}
          <span className="text-muted-foreground ml-2">&rdquo;</span>
        </p>

        <div className="flex items-center gap-4">
          <img
            src="/testimonial-avatar.png"
            alt="Marcus Elliot"
            className="w-14 h-14 rounded-full border-[3px] border-foreground object-cover"
          />
          <div>
            <div className="text-base font-semibold leading-7 text-foreground">
              Marcus Elliot
            </div>
            <div className="text-sm font-normal leading-5 text-muted-foreground">
              Head of Digital Marketing
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
